<template>
  <b-card style="padding:40px;">
    <h5><b>MONTHLY FORECAST (PREVIEW)</b></h5>
    <hr />
    <div>
      <b-row>
        <b-col md="3">
          <b-form-group>
            <label :for="`input-year`">Year</label>
            <b-input v-model="form.year" class="input-new" required disabled />
          </b-form-group>
        </b-col>

        <!-- Display Month -->
        <b-col md="3">
          <b-form-group>
            <label :for="`input-month`">Month</label>
            <b-input
              :value="getMonth(form.month)"
              class="input-new"
              required
              disabled
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-tabs content-class="mt-3">
        <b-tab title="Week 1">
          <TableMonthlyForecastPreview :fields="fields" :items="items.data1" />
        </b-tab>
        <b-tab title="Week 2">
          <TableMonthlyForecastPreview :fields="fields" :items="items.data2" />
        </b-tab>
        <b-tab title="Week 3">
          <TableMonthlyForecastPreview :fields="fields" :items="items.data3" />
        </b-tab>
        <b-tab title="Week 4">
          <TableMonthlyForecastPreview :fields="fields" :items="items.data4" />
        </b-tab>
        <b-tab title="Week 5">
          <TableMonthlyForecastPreview :fields="fields" :items="items.data5" />
        </b-tab>

        <b-row>
          <b-col align="right">
            <b-button variant="primary" size="sm" @click="onClickBack">
              BACK
            </b-button>
            &nbsp;&nbsp;&nbsp;
            <b-button variant="primary" size="sm" @click="onClickSubmit"
              >SUBMIT</b-button
            >
          </b-col>
        </b-row>
      </b-tabs>
    </div>
  </b-card>
</template>

<script>
import TableMonthlyForecastPreview from "@/table/user/monthlyForecast/TableMonthlyForecastPreview";

export default {
  data() {
    return {
      category: "",
      id: "",
      items: [
        {
          name: "",
          sku: "",
          qty: "",
          product_id: ""
        }
      ],
      form: {
        id: "",
        category: "",
        year: "",
        month: "",
        type: "",
        proCat: ""
      },
      fields: [
        {
          label: "No",
          key: "no",
          sortable: false
        },
        {
          label: "Product Name",
          key: "name",
          sortable: true
        },
        {
          label: "Quantity",
          key: "quantity",
          sortable: true
        },
        {
          label: "Quantity Type",
          key: "quantity_type",
          sortable: true
        }
      ]
    };
  },
  created() {
    let data = JSON.parse(this.$route.query.data);
    // this.items = data.items;
    this.id = data.id;
    // this.category = data.category;
    // this.form.year = data.year;
    // this.form.month = data.month;

    // this.form.type = parseInt(data.proCat) === 1 ? "UHT" : "Pasteurized";
    this.form.proCat = data.proCat;
    this.showMF();
  },
  methods: {
    onClickBack() {
      this.$router.go(-1);
    },

    showMF() {
      this.$store
        .dispatch("showMF", {
          fc_id: this.id
        })
        .then(res => {
          if (res.data.response.code === 100) {
            // get id
            this.form.id = res.data.data.fc_id;
            // get month
            this.form.month = res.data.data.month;
            // get year
            this.form.year = res.data.data.year;

            if (
              res.data.data.fc_week.length > 1 ||
              res.data.data.fc_week !== undefined
            ) {
              let week = res.data.data.fc_week;
              week.forEach(item => {
                // Week 1
                if (item.week === 1) {
                  let week1 = [];
                  item.pro_stock.forEach(item2 => {
                    week1.push({
                      isActive: true,
                      pro_stock_id: item2.pro_stock_id,
                      name: item2.product.name,
                      sku: item2.product_id,
                      quantity: item2.quantity,
                      quantity_type: item2.quantity_type === 1 ? "Pcs" : "Ctn",
                      index: item2.index,
                      action: "fas fa-user"
                    });
                  });
                  this.items.data1 = week1;
                }

                // Week 2
                if (item.week === 2) {
                  let week2 = [];
                  item.pro_stock.forEach(item2 => {
                    week2.push({
                      isActive: true,
                      pro_stock_id: item2.pro_stock_id,
                      name: item2.product.name,
                      sku: item2.product_id,
                      quantity: item2.quantity,
                      quantity_type: item2.quantity_type === 1 ? "Pcs" : "Ctn",
                      index: item2.index,
                      action: "fas fa-user"
                    });
                  });
                  this.items.data2 = week2;
                }

                // Week 3
                if (item.week === 3) {
                  let week3 = [];
                  item.pro_stock.forEach(item2 => {
                    week3.push({
                      isActive: true,
                      pro_stock_id: item2.pro_stock_id,
                      name: item2.product.name,
                      sku: item2.product_id,
                      quantity: item2.quantity,
                      quantity_type: item2.quantity_type === 1 ? "Pcs" : "Ctn",
                      index: item2.index,
                      action: "fas fa-user"
                    });
                  });
                  this.items.data3 = week3;
                }

                // Week 4
                if (item.week === 4) {
                  let week4 = [];
                  item.pro_stock.forEach(item2 => {
                    week4.push({
                      isActive: true,
                      pro_stock_id: item2.pro_stock_id,
                      name: item2.product.name,
                      sku: item2.product_id,
                      quantity: item2.quantity,
                      quantity_type: item2.quantity_type === 1 ? "Pcs" : "Ctn",
                      index: item2.index,
                      action: "fas fa-user"
                    });
                  });
                  this.items.data4 = week4;
                }

                // Week 5
                if (item.week === 5) {
                  let week5 = [];
                  item.pro_stock.forEach(item2 => {
                    week5.push({
                      isActive: true,
                      pro_stock_id: item2.pro_stock_id,
                      name: item2.product.name,
                      sku: item2.product_id,
                      quantity: item2.quantity,
                      quantity_type: item2.quantity_type === 1 ? "Pcs" : "Ctn",
                      index: item2.index,
                      action: "fas fa-user"
                    });
                  });
                  this.items.data5 = week5;
                }
              });
            }
          }
        });
    },

    onClickSubmit() {
      this.$store
        .dispatch("updateStatusMF", {
          id: this.id,
          category: 3,
          status: 5
        })
        .then(res => {
          if (res.data.response.code === 1) {
            this.$router.push({
              path: `mf_view?id=${this.id}&cat=3&pro_cat=${this.form.proCat}&from=created`
            });
          }
        });
    },

    // Convert to month
    getMonth(month) {
      switch (parseInt(month)) {
        case 1:
          return "January";
        case 2:
          return "February";
        case 3:
          return "March";
        case 4:
          return "April";
        case 5:
          return "May";
        case 6:
          return "June";
        case 7:
          return "July";
        case 8:
          return "August";
        case 9:
          return "September";
        case 10:
          return "October";
        case 11:
          return "November";
        case 12:
          return "December";
      }
    }
  },
  components: {
    TableMonthlyForecastPreview
  }
};
</script>
<style lang="css" scoped></style>
